import { connect } from 'react-redux';
import { get } from 'lodash';
import { moment } from '@eb/date';

import { formatDate, constants as dateTimeConstants } from '@eb/datetime';

const { ISO_8601_DATE_FORMAT } = dateTimeConstants;

const mapFormValuesToProps = (
    formState,
    { prefix = '', maxEndDateDays = 366, locale },
) => {
    const formValues = formState.values || {};

    // Use _.get to deal with object prefix keys with arrays e.g. `a[0].lolcats`
    const startDate = get(formValues, `${prefix}startDate`);
    const endDate = get(formValues, `${prefix}endDate`);

    let minDate;
    let maxDate;

    if (startDate) {
        minDate = formatDate(startDate);
        maxDate = formatDate(
            moment(startDate, ISO_8601_DATE_FORMAT).add(maxEndDateDays, 'days'),
        );
    }

    return {
        locale,
        startDate,
        endDate,
        minDate,
        maxDate,
    };
};

const endDateConnector = (component, getFormState, options = {}) =>
    connect((state) =>
        mapFormValuesToProps(getFormState(state), {
            ...options,
            locale: state.localeInfo.locale,
        }),
    )(component);

export default endDateConnector;
